interface LoginFormProps {
  onLogin: (username: string, password: string) => void;
  error: string;
}

export default function LoginForm({ onLogin, error }: LoginFormProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    onLogin(username, password);
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="card">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-white mb-2">TPA Santri Management</h1>
          <p className="text-gray-400">Masuk untuk melanjutkan</p>
        </div>

        {error && (
          <div className="bg-red-900/50 border border-red-700 text-red-300 px-4 py-3 rounded-lg mb-6">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Username
            </label>
            <input
              type="text"
              className="input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Masukkan username"
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Password
            </label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Masukkan password"
              required
            />
          </div>

          <button
            type="submit"
            className="btn-primary w-full flex items-center justify-center"
            disabled={loading}
          >
            {loading ? <div className="loading-spinner"></div> : 'Masuk'}
          </button>
        </form>

        <div className="mt-6 p-4 bg-dark-200 rounded-lg">
          <p className="text-sm text-gray-400 font-medium mb-2">Demo Accounts:</p>
          <div className="space-y-1 text-xs text-gray-500">
            <p><span className="badge badge-daerah px-2 py-0.5 rounded">DAERAH</span> admin / admin123</p>
            <p><span className="badge badge-desa px-2 py-0.5 rounded">DESA</span> desa1 / desa123</p>
            <p><span className="badge badge-kelompok px-2 py-0.5 rounded">KELOMPOK</span> kelompok1 / kelompok123</p>
          </div>
        </div>
      </div>
    </div>
  );
}
